import React from "react"
import Tab from "./tab"
import { tabData } from "./tab-data"

const Tabs = ({ selectedTab, handleTabChange, className }) => {
  return (
    <div className={`flex justify-around mt-3 ${className}`}>
      {tabData.map((tab) => {
        return (
          <Tab
            key={tab.name}
            {...tab}
            selected={tab.name === selectedTab}
            handleTabChange={handleTabChange}
          />
        )
      })}
    </div>
  )
}

export default Tabs
